import { SectionDetailsModel } from '../models/section_detail_model';
import { ICampus } from '../../../interfaces/scheduler_interfaces';
import { IDefineCommand, ICommand, IQuery, IQueryMediator } from 'core-ts-types';

angular
  .module('capability-ng-scheduler')
  .factory(
    'getSectionDetailsCommand',
    (
      ngSectionDetailsModel: SectionDetailsModel,
      defineCommandORM: IDefineCommand,
      QueryMediator: IQueryMediator
    ): ICommand => {
      return defineCommandORM('getSectionDetailsCommand', (deferred: ng.IDeferred<IQuery[]>, sectionId: number) => {
        ngSectionDetailsModel.clear().write({ id: sectionId });
        deferred.resolve(QueryMediator.runQueries(ngSectionDetailsModel));
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_details/commands/get_section_details_command.ts